var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videodome",staticStyle:{"object-fit":"fill"},attrs:{"autoplay":"","controls":"","width":"100%","height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }